import axios from 'axios'
import { setupInterceptors } from './interceptors'
import { isMobile } from '@/utils'

const baseEnv =
  localStorage.getItem('_baseURL') ?? (import.meta.env.MODE === 'development' ? '/dev' : '')

export function createAxios(options: any = {}) {
  const defaultOptions = {
    baseURL: baseEnv + '/auth/auth-server',
    timeout: 20000
  }
  const service = axios.create({
    ...defaultOptions,
    ...options,
    headers: { ...options?.headers, 'SOURCE-DEVICE-TYPE': isMobile() ? 'H5' : 'PC' }
  })
  // 请求拦截, 返回拦截
  setupInterceptors(service)
  return service
}

export const axiosRequest = createAxios()
